// @ts-nocheck
import React from 'react';
import { ApplyPluginsType } from '/data1/jenkins/workspace/aplus_tiger_202111invite8a39a4a0-63c6-401a-b0da-8b1d91baec64_tiger-platform_huya-promo_202111invite_19893_nodejs_prod/node_modules/.pnpm/@umijs+runtime@3.5.41_react@16.14.0/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';

export function getRoutes() {
  const routes = [
  {
    "exact": true,
    "path": "/index.html",
    "component": require('@/pages/index/index.tsx').default,
    "title": "邀请送现金"
  },
  {
    "exact": true,
    "path": "/qrcode.html",
    "component": require('@/pages/qrcode/index.tsx').default,
    "title": "邀请送现金"
  },
  {
    "exact": true,
    "path": "/picshare1.html",
    "component": require('@/pages/share/index.tsx').default,
    "title": "邀请送现金"
  },
  {
    "exact": true,
    "path": "/picshare2.html",
    "component": require('@/pages/share/index.tsx').default,
    "title": "邀请送现金"
  },
  {
    "exact": true,
    "path": "/picshare3.html",
    "component": require('@/pages/share/index.tsx').default,
    "title": "邀请送现金"
  },
  {
    "exact": true,
    "path": "/share.html",
    "component": require('@/pages/share/index.tsx').default,
    "title": "邀请送现金"
  },
  {
    "exact": false,
    "path": "/share1.html",
    "component": require('@/pages/share/index.tsx').default,
    "title": "邀请送现金"
  },
  {
    "exact": true,
    "path": "/share2.html",
    "component": require('@/pages/share/index.tsx').default,
    "title": "邀请送现金"
  },
  {
    "exact": true,
    "path": "/share3.html",
    "component": require('@/pages/share/index.tsx').default,
    "title": "邀请送现金"
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
